import { Box, Stack, Typography } from "@mui/material";
import { TagChip } from "../../components/TagChip";

export const StageItem = ({
  stage,
  title,
  description,
}: {
  stage: number;
  title: string;
  description: string;
}) => {
  return (
    <Box
      sx={{
        pb: 3,
        mb: 2,
        borderBottom: "1px solid #E3E3E3",
      }}
    >
      <Stack direction="row" spacing={1} sx={{ mb: "12px" }}>
        <Typography variant="body1" component="p" fontWeight={800}>
          {title}
        </Typography>
        <TagChip>Stage: {stage}</TagChip>
      </Stack>
      <Typography variant="body1" component="p">
        {description}
      </Typography>
    </Box>
  );
};
